import React, { useEffect, useState } from "react";
import { Table, Row, Col, Space, Typography } from "antd";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import columns from "@staticData/admin/adminCoreProductsTableColumns";
import moment from "moment-jalaali";
import DeleteCoreProduct from "@general/deleteCoreProduct";


function CoreServicesTable({
  data,
  onPageChange,
  currentPage,
  onSort,
  loading,
  onOpenDrawer,
  onDataUpdate
}) {
  const [tableData, setTableData] = useState([]);
  const { getProductsCount: count, getProducts: services } = data;
  useEffect(() => {
    const initialTableData = [];
    services.map((service) => {
      const {
        id,
        name,
        createdAt,
        category,
        description,
      } = service;
      initialTableData.push({
        key: id,
        name,
        category,
        createdAt: moment(createdAt).format("jYYYY/jMM/jDD"),
        description,
        details: (
          <Space>
            <a onClick={() => onOpenDrawer(id, category)}>
              <EyeOutlined />
            </a>
            |
            <DeleteCoreProduct id={id} name={name} onDeleteCoreProduct={onDataUpdate}>
              <a>
                <DeleteOutlined />
              </a>
            </DeleteCoreProduct>
          </Space>
        ),
      });
    });
    setTableData(initialTableData);
  }, [services]);

  const onChange = (pagination, filters, sorter, extra) => {
    if (extra.action === "sort") {
      onSort(sorter);
    }
    if (extra.action === "paginate") {
      onPageChange(pagination.current);
    }
  };

  return (
    <>
      <Row>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={tableData}
            pagination={{
              total: count,
              current: currentPage,
              showSizeChanger: false,
            }}
            onChange={onChange}
            loading={loading}
            scroll={{ x: 800 }}
          />
        </Col>
      </Row>
    </>
  );
}

export default CoreServicesTable;
